// Arquivo sem imports de runtime, de propósito (mesmo padrão de
// src/lib/statusBoleto.ts): fica testável com `node --test` puro, sem puxar
// o client do Supabase (que depende de import.meta.env, exclusivo do Vite).
// `import type` é seguro aqui porque é apagado por inteiro na transpilação —
// nunca vira um import de verdade em tempo de execução.
import type { CobrancaAcaoManual } from '../../types';

export type EstadoNotificacaoD17 =
  | { tipo: 'normal' }
  | { tipo: 'sem_cpf' }
  | { tipo: 'ja_notificada'; enviadoEm: string; resultado: string | null };

/**
 * O que o card D+17 (fila de contato humano) deve mostrar em vez de
 * "Gerar notificação"/"Dispensar", quando aplicável.
 *
 * 'sem_cpf': a linha não tem CPF/CNPJ vinculado (UC sem o documento
 * cadastrado) — não dá pra saber se este cliente já foi notificado sob outra
 * UC. Não bloqueia a ação, só avisa (ver spec, seção 5).
 *
 * 'ja_notificada': já existe notificação extrajudicial enviada para este
 * CPF/CNPJ (em qualquer UC) — não faz sentido oferecer "Gerar notificação"
 * de novo; o caminho certo é registrar o desfecho em "Gerenciar negociação".
 */
export function derivarEstadoNotificacaoD17(
  acao: Pick<CobrancaAcaoManual, 'etapa' | 'cpf_cnpj_cliente' | 'notificacao_previa'>
): EstadoNotificacaoD17 {
  if (acao.etapa !== 'D+17') return { tipo: 'normal' };
  if (!acao.cpf_cnpj_cliente) return { tipo: 'sem_cpf' };
  if (!acao.notificacao_previa) return { tipo: 'normal' };
  return {
    tipo: 'ja_notificada',
    enviadoEm: acao.notificacao_previa.enviado_cliente_em,
    resultado: acao.notificacao_previa.resultado_verificacao,
  };
}
